import LegalPage from "../Components/LegalPage.js";

export function TermsOfService() {
  return <LegalPage bodyKey="legal.tos.body" />;
}
